/**
 * Versão/ambiente do build, compartilhado pelas 3 superfícies (admin/PDV, PWA
 * cliente, PWA entregador). Lê as VITE_* embutidas no build (OPS-01 / REL-UI).
 * Valores ausentes caem para "dev"/"production" — nunca quebra.
 */

export interface VersionInfo {
    /** SemVer sem o "v" (ex.: "0.1.0") ou "dev" quando ausente. */
    version: string
    /** SHA curto do commit (7 chars) ou "". */
    sha: string
    /** Ambiente do build: production | staging | local | … */
    env: string
    isProduction: boolean
    /** Rótulo pronto para badge: "v0.1.0 · abc1234" | "dev". */
    label: string
}

function readEnv(key: string): string {
    return ((import.meta.env as Record<string, string | undefined>)[key] ?? '').trim()
}

export function appEnv(): string {
    return readEnv('VITE_APP_ENV') || 'production'
}

export function versionInfo(): VersionInfo {
    const env = appEnv()
    const rawVersion = readEnv('VITE_APP_VERSION')
    const sha = readEnv('VITE_BUILD_SHA').slice(0, 7)
    const version = rawVersion || 'dev'

    const label = version === 'dev'
        ? (sha ? `dev · ${sha}` : 'dev')
        : (sha ? `v${version} · ${sha}` : `v${version}`)

    return { version, sha, env, isProduction: env === 'production', label }
}

/**
 * Rótulo do selo de ambiente. Vazio em produção (não mostra ribbon).
 */
export function envRibbonLabel(): string {
    const env = appEnv()
    if (env === 'production') return ''
    if (env === 'staging') return 'HOMOLOGAÇÃO'
    if (env === 'local') return 'LOCAL'
    return env.toUpperCase()
}
